import * as React from "react";
import {Button} from "@octopusdeploy/design-system-components";
import {ChevronUpIcon, ChevronDownIcon} from "@octopusdeploy/design-system-icons";

interface CardExpandableProps {
    expanded?: boolean;
    tabIndex?: number;
    position?: boolean;
    onExpanding?(event: any): void;
}

class CardExpandable extends React.Component<CardExpandableProps> {
    render() {
        const label = this.props.expanded ? "Collapse" : "Expand";
        const icon = this.props.expanded ? <ChevronUpIcon size={20} /> : <ChevronDownIcon size={20} />;
        return (
            <Button
                importance="ghost"
                size="small"
                icon={icon}
                onClick={(e) => this.props.onExpanding?.(e)}
                title={label}
                accessibleName={label}
                tabIndex={this.props.tabIndex === -1 ? -1 : undefined}
                aria-expanded={this.props.expanded ? "true" : "false"}
            />
        );
    }
}

export default CardExpandable;
